var divider_viewer_rtlignore_default = {
  "divider-container": "sL2Kk",
  "divider-container--double": "LMDnb",
  "divider": "jzqge",
  "divider--single": "OL7D0",
  "divider--double": "_0IQ7U",
  "divider--dashed": "CE7Ph",
  "divider--dotted": "_1eZiT",
  "divider--small": "abROW",
  "divider--medium": "VSA2x",
  "divider--large": "kr0U8",
  "divider--left": "pEltG",
  "divider--center": "Szuyu",
  "divider--right": "FaeIq",
  "svgFixerContainer": "kjemj",
  "emptyChar": "_4dybx"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
